
export default function CheckBoxGroup({title,name,value,onChange,disabled=false}) {
  return (
    <div className="d-flex">
            <input type="checkbox" name={name} onChange={onChange} value={value} checked={value} disabled={disabled} />
            <div className='label'> {title}</div>
    </div>
  )
}
